import { render, staticRenderFns } from "./roleManage.vue?vue&type=template&id=acb8f2aa&scoped=true"
import script from "./roleManage.vue?vue&type=script&lang=js"
export * from "./roleManage.vue?vue&type=script&lang=js"
import style0 from "./roleManage.vue?vue&type=style&index=0&id=acb8f2aa&prod&lang=less"
import style1 from "./roleManage.vue?vue&type=style&index=1&id=acb8f2aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb8f2aa",
  null
  
)

export default component.exports